import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { setGreenhouses } from "../../slices/greenhouseSlice"
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Grid,
  Link
} from "@mui/material";
import { GridColDef, GridEventListener, GridSelectionModel, GridApi, GridCellValue } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import NewGreenhouse from "../../components/NewGreenhouse";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import axios from "axios";
import { IGreenhouse, IGreenhouseState } from "../../interfaces/IGreenhouse";
import { IBay } from "../../interfaces/IBay";
import { IZone } from "../../interfaces/IZone";
import { IBench } from "../../interfaces/IBench";
import { ITray } from "../../interfaces/ITray";
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormControlLabel } from "@mui/material";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ConfirmDialog, { confirmDialog } from "../../components/ConfirmDialog";
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import MovementDialog from "../../components/MovementDialog";
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import LightsIcon from '@mui/icons-material/LightMode';
import HeatIcon from '@mui/icons-material/Waves';
import GrassIcon from '@mui/icons-material/Grass';
import { orange } from '@mui/material/colors';
import { green } from '@mui/material/colors';
import { DatePicker } from "@mui/x-date-pickers";
import { ThunkDispatch, AnyAction, Dispatch } from "@reduxjs/toolkit";
import { ICrewState } from "../../interfaces/ICrew";
import { ISelection } from "../../interfaces/ISelection";
import { IUserState } from "../../interfaces/IUser";
import Badge from '@mui/material/Badge';
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#FF0000',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  showLights?: boolean,
  showHeat?: boolean,
  showGrass?: boolean,
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, showLights, showHeat, showGrass, ...other } = props;
  useEffect(() => {
    console.log(props);
  }, [props])
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {(showLights != undefined && showLights == true) && <LightsIcon sx={{ color: orange[900], position: 'absolute', right: 125, top: 15, }} />}
      {(showHeat != undefined && showHeat == true) && <HeatIcon sx={{ color: (theme) => theme.palette.grey[700], position: 'absolute', right: 95, top: 15, }} />}
      {(showGrass != undefined && showGrass == true) && <GrassIcon sx={{ color: green[900], position: 'absolute', right: 65, top: 15, }} />}
      {((showLights != undefined && showLights == true) && (showHeat != undefined && showHeat == true) && (showGrass != undefined && showGrass == true)) && <Typography sx={{ color: green[900], position: 'absolute', right: 165, top: 15, }}>OPTIMIZED GROWING</Typography>}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const actions = [
  { icon: <FileCopyIcon />, name: 'Copy' },
  { icon: <SaveIcon />, name: 'Save' },
  { icon: <PrintIcon />, name: 'Print' },
  { icon: <ShareIcon />, name: 'Share' },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type Props = {
  showActionMenu: boolean,
  setSelectedTrays?: React.Dispatch<React.SetStateAction<ITray[]>>,
  setTitle?: boolean | undefined
}

export default function Greenhouses(props: Props) {

  function AddClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  function ImportClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setImportOpen(true);
  }

  const [open, setOpen] = useState(false);

  const [importOpen, setImportOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={AddClicked} buttonLabel="ADD NEW GREENHOUSE" />,
    <ActionButton action={ImportClicked} buttonLabel="IMPORT GREENHOUSE" />,
    
  ];

  const dispatch = useAppDispatch();
  var applicationState: IApplication = {
    pageTitle: "Greenhouse Management",
    backgroundPath: "/assets/images/spaceallocationbg.jpg"
  }
  const [movementTitle, setMovementTitle] = useState("");
  const [movementObject, setMovementObject] = useState<IGreenhouse | IBay | IZone | IBench>();
  const [movementType, setMovementType] = useState<any>();
  if (props.setTitle == true || props.setTitle == undefined) {
    dispatch(setPageTitle(applicationState));
  }
  useEffect(() => {
    GetGreenhouses(dispatch);
  }, []);

  const { handleSubmit: handleBaySubmit, register: bayRegister, control:bayControl, reset: bayReset, setValue: setBayValue, getValues: getBayValues } = useForm<IBay>();
  const onBaySubmit: SubmitHandler<IBay> = async data => {
    data.greenhouseID = currentGreenhouse?.id!;
    let bayData = await submitBay(data);
    console.log("BAY DATA", bayData);
    handleBayClose();
    if (bayData) {
      let updatedBays = bays.filter(i => i.id === bayData.id).length > 0 ? bays.map(obj => obj.id === bayData.id ? bayData : obj) : [...bays, bayData!]
      setBays(updatedBays);
    }
    bayReset();
  };

  const submitGreenhouse = async (data: IGreenhouse): Promise<IGreenhouse> => {
    console.log("IN SUBMIT GREENHOUSE", data);
    if (data.id == 0) {
      let greenhouseData = axios.post<IGreenhouse>(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/`, data)
        .then(x => { return x.data });
      return greenhouseData;
    } else {
      let greenhouseData = axios.put<IGreenhouse>(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/${data.id}`, data)
        .then(x => { return x.data });
      return greenhouseData;
    }
  }

  const submitBay = async (data: IBay): Promise<IBay> => {
    console.log("IN SUBMIT BAY", data);
    if (data.id == 0) {
      let bayData = axios.post<IBay>(`${process.env.REACT_APP_ENDPOINT}/api/Bays/`, data)
        .then(x => { return x.data });
      return bayData;
    } else {
      let bayData = axios.put<IBay>(`${process.env.REACT_APP_ENDPOINT}/api/Bays/${data.id}`, data)
        .then(x => { return x.data });
      return bayData;
    }
  }

  const { handleSubmit: handleZoneSubmit, register: zoneRegister, reset: zoneReset, setValue: setZoneValue, getValues: getZoneValues } = useForm<IZone>();
  const onZoneSubmit: SubmitHandler<IZone> = async data => {
    data.bayID = currentBay?.id!;
    let zoneData = await submitZone(data);
    handleZoneClose();
    if (zoneData) {
      let updatedZones = zones.filter(i => i.id === zoneData.id).length > 0 ? zones.map(obj => obj.id === zoneData.id ? zoneData : obj) : [...zones, zoneData!]
      setZones(updatedZones);
    }
    zoneReset();
  };

  const submitZone = async (data: IZone): Promise<IZone> => {
    console.log("IN SUBMIT ZONE", data);
    if (data.id == 0) {
      let zoneData = axios.post<IZone>(`${process.env.REACT_APP_ENDPOINT}/api/Zones/`, data)
        .then(x => { return x.data });
      return zoneData;
    } else {
      let zoneData = axios.put<IZone>(`${process.env.REACT_APP_ENDPOINT}/api/Zones/${data.id}`, data)
        .then(x => { return x.data });
      return zoneData;
    }
  }

  const { handleSubmit: handleBenchSubmit, register: benchRegister, reset: benchReset, setValue: setBenchValue, getValues: getBenchValues } = useForm<IBench>();
  const onBenchSubmit: SubmitHandler<IBench> = async data => {
    data.zoneID = currentZone?.id!;
    let benchData = await submitBench(data);
    console.log("GR DATA", benchData);
    handleBenchClose();
    if (benchData) {
      let updatedBenches = benches.filter(i => i.id === benchData.id).length > 0 ? benches.map(obj => obj.id === benchData.id ? benchData : obj) : [...benches, benchData!]
      setBenches(updatedBenches);
    }
    benchReset();
  };

  const submitBench = async (data: IBench): Promise<IBench> => {
    console.log("IN SUBMIT BAY", data);
    if (data.id == 0) {
      let bayData = axios.post<IBench>(`${process.env.REACT_APP_ENDPOINT}/api/Benches/`, data)
        .then(x => { return x.data });
      return bayData;
    } else {
      let bayData = axios.put<IBench>(`${process.env.REACT_APP_ENDPOINT}/api/Benches/${data.id}`, data)
        .then(x => { return x.data });
      return bayData;
    }
  }


  const fetchedGreenhouses = useAppSelector((state) => state.greenhouses);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  
  const handleFileSelected = (e: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("Hello!");
    if (e.target.files != null) {
      const files = Array.from(e.target.files);
      const headers = {
        'Content-Type': 'multipart/form-data'
      }
      var bodyFormData = new FormData();
      bodyFormData.append('files', files[0]);
      axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/Upload`, bodyFormData, {
        headers: headers
      }).then((data) => {
        GetGreenhouses(dispatch);
      });
    }
  }

  
  
  const [trayOpen, setTrayOpen] = React.useState(false);
  const [movementOpen, setMovementOpen] = React.useState(false);
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [bayOpen, setBayOpen] = React.useState(false);
  const [zoneOpen, setZoneOpen] = React.useState(false);
  const [benchOpen, setBenchOpen] = React.useState(false);
  const [greenhouseOpen, setGreenhouseOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleImportOpen = () => {
    setImportOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleImportClose = () => {
    setImportOpen(false);
  };

  const handleBayOpen = () => {
    setBayOpen(true);
  };

  const handleBayClose = () => {
    setBayOpen(false);
  };

  const handleZoneOpen = () => {
    setZoneOpen(true);
  };

  const handleZoneClose = () => {
    setZoneOpen(false);
  };

  const handleBenchOpen = () => {
    setBenchOpen(true);
  };

  const handleBenchClose = () => {
    setBenchOpen(false);
  };

  const handleTrayClose = () => {
    console.log("Tray Closed?");
    setTrayOpen(false);
  }

  const handleMovementClose = () => {
    console.log("Movement Closed?");
    setMovementOpen(false);
  }

  const handleGreenhouseOpen = () => {
    console.log("CURRENT GREENHOUSE", currentGreenhouse);
    greenhouseReset(currentGreenhouse);
    setGreenhouseOpen(true);
  };

  const handleGreenhouseClose = () => {
    setGreenhouseOpen(false);
  };

  const columns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          return alert(JSON.stringify(thisRow, null, 4));
        };

        return <Button variant="contained" color="secondary" onClick={onClick}>EDIT GREENHOUSE</Button>;
      }
    },
  ];

  const bayColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, hide: true },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          console.log("BAYS", bays)
          console.log("THIS ROW", thisRow.id);
          let bay = bays.find(x => x.id == thisRow.id);
          console.log("BAY", bay);
          bayReset(bay);
          handleBayOpen();
        };

        const moveOnClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let bay = bays.find(x => x.id == thisRow.id);
          setMovementTitle(`MOVE BAY: ${bay?.name.toUpperCase()} `);
          setMovementObject(bay);
          setMovementType("bay");
          setMovementOpen(true);
        };

        return <Grid>
          <Button variant="contained" color="secondary" onClick={onClick}>EDIT BAY</Button>
          <Button variant="contained" color="primary" onClick={moveOnClick} sx={{ marginLeft: 1 }}>MOVE BAY</Button>
        </Grid>
      }
    },
  ];

  const zoneColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, hide:true },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let zone = zones.find(x => x.id == thisRow.id);
          zoneReset(zone);
          handleZoneOpen();
        };

        const moveOnClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let zone = zones.find(x => x.id == thisRow.id);
          setMovementTitle(`MOVE ZONE: ${zone?.name.toUpperCase()} `);
          setMovementObject(zone);
          setMovementType("zone");
          setMovementOpen(true);
        };

        return <Grid>
          <Button variant="contained" color="secondary" onClick={onClick}>EDIT ZONE</Button>
          <Button variant="contained" color="primary" onClick={moveOnClick} sx={{ marginLeft: 1 }}>MOVE ZONE</Button>
        </Grid>
      }
    },
  ];

  const benchColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, hide: true },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let bench = benches.find(x => x.id == thisRow.id);
          console.log("BENCH", bench);
          benchReset(bench);
          handleBenchOpen();
        };

        const moveOnClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let bench = benches.find(x => x.id == thisRow.id);
          setMovementTitle(`MOVE BENCH: ${bench?.name.toUpperCase()} `);
          setMovementObject(bench);
          setMovementType("bench");
          setMovementOpen(true);
        };

        return <Grid>
          <Button variant="contained" color="secondary" onClick={onClick}>EDIT BENCH</Button>
          <Button variant="contained" color="primary" onClick={moveOnClick} sx={{ marginLeft: 1 }}>MOVE BENCH</Button>
        </Grid>
      }
    },
  ];

  const trayColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, hide: true },
    { field: 'barcode', headerName: 'Barcode', width: 250 },
    { field: 'description', headerName: 'Description', width: 350 },
    { field: 'species', headerName: 'Species', width: 300 },
    { field: 'variety', headerName: 'Variety', width: 250 },
    { field: 'color', headerName: 'Color', width: 200 },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "transparent",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#191919',
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  type AccordianProps = {
    id: number,
    name: string,
    heatedFloors: boolean
    bays: IBay[]
  }

  const [openAccordianId, setOpenAccordianId] = useState(0);
  const [currentGreenhouse, setCurrentGreenhouse] = useState<IGreenhouse>();
  const [bays, setBays] = useState<IBay[]>([]);
  const [selectedBays, setSelectedBays] = useState<IBay[]>([]);
  const [currentBay, setCurrentBay] = useState<IBay>();
  const [zones, setZones] = useState<IZone[]>([]);
  const [currentZone, setCurrentZone] = useState<IZone>();
  const [benches, setBenches] = useState<IBench[]>([]);
  const [currentBench, setCurrentBench] = useState<IBench>();
  const [trays, setTrays] = useState<ITray[]>([]);
  const [currentTrays, setCurrentTrays] = useState<ITray[]>([]);

  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);

  useEffect(() => {
    console.log(selectionModel);
  }, [selectionModel])


  const CustomAccordian = ({ id, name, heatedFloors }: AccordianProps) => {
    const handleBayRowClick: GridEventListener<'rowClick'> = (params) => {
      let bay = bays.find(x => x.id === params.row.id);
      if (bay !== undefined) {
        setCurrentBay(bay);
        setZones(bay.zones);
        setValue(1);
      };
    };

    const handleZoneRowClick: GridEventListener<'rowClick'> = (params) => {
      let zone = zones.find(x => x.id === params.row.id);
      if (zone !== undefined) {
        setCurrentZone(zone);
        setBenches(zone.benches)
        setValue(2);
      };
    };

    const handleBenchRowClick: GridEventListener<'rowClick'> = (params) => {
      let bench = benches.find(x => x.id === params.row.id);
      if (bench !== undefined) {
        setCurrentBench(bench);
        setTrays(bench.trays)
        setValue(3);
      };
    };

    return (
      <Accordion key={id} expanded={id === openAccordianId} disableGutters >
        <AccordionSummary onClick={() => {
          openAccordianId !== id ? setOpenAccordianId(id) : setOpenAccordianId(0);
          let greenhouse = fetchedGreenhouses.greenhouses.find(x => x.id === id);
          setZones([]);
          setBenches([]);
          setTrays([]);
          setValue(0);
          setCurrentGreenhouse(undefined);
          setCurrentBay(undefined);
          setCurrentZone(undefined);
          setCurrentBench(undefined);
          if (greenhouse != undefined) {
            setCurrentGreenhouse(greenhouse);
            setBays(greenhouse.bays);
          }
        }}
          expandIcon={<ExpandMoreRounded />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ backgroundImage: 'linear-gradient(#BBB, #FFF);' }}
        >
          <Grid container spacing={1}>
            <Grid item xs={8} sx={{ mt: 1 }}>
              <Stack direction="row" spacing={2} sx={{ flexGrow: 1 }}>
              <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  variant="dot"
                >
                   <Avatar sx={{ borderRadius:'0', backgroundColor:"darkblue" }}>{name.slice(0, 2)} </Avatar>
                </StyledBadge>
                <Item><Typography variant='h5' fontWeight={600} textAlign='left'>{name}</Typography></Item>
              </Stack>
            </Grid>
            <Grid item xs={4}>
              {/* <LightsIcon sx={{color: orange[900], position: 'absolute', right: 125, top: 30,}} />  */}
              {heatedFloors && <HeatIcon sx={{ color: (theme) => theme.palette.grey[700], position: 'absolute', right: 95, top: 30, }} />}
              {/* <GrassIcon sx={{color: green[900], position: 'absolute', right: 65, top: 30,}} /> */}
              {/* <Typography sx={{color: green[900], position: 'absolute', right: 165, top: 30,}}>OPTIMIZED GROWING</Typography> */}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails >
          <Grid item xs={4} sx={{ marginBottom: 1 }}>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" color="primary" onClick={handleGreenhouseOpen}>Edit Greenhouse</Button>
              <Button variant="contained" color="primary" onClick={() => {
                setMovementTitle(`MOVE GREENHOUSE: ${currentGreenhouse?.name.toUpperCase()} `);
                setMovementObject(currentGreenhouse);
                setMovementType("greenhouse");
                setMovementOpen(true);
              }
              }>MOVE GREENHOUSE</Button>
            </Stack>
          </Grid>
          <Box sx={{ width: '100%', paddingtop: '0' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ paddingtop: '0' }}>
                <Tab label="Bays" {...a11yProps(0)} />
                <Tab label="Zones" disabled={currentBay === undefined} {...a11yProps(1)} />
                <Tab label="Benches" disabled={currentZone === undefined} {...a11yProps(2)} />
                <Tab label="Trays" disabled={currentBench === undefined} {...a11yProps(3)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { bayReset({}); handleBayOpen(); }}>CREATE NEW BAY</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={bays}
                  onRowClick={handleBayRowClick}
                  disableSelectionOnClick
                  columns={bayColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { zoneReset({}); handleZoneOpen(); }}>CREATE NEW ZONE</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={zones}
                  onRowClick={handleZoneRowClick}
                  columns={zoneColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { benchReset({}); handleBenchOpen(); }}>CREATE NEW BENCH</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={benches}
                  onRowClick={handleBenchRowClick}
                  disableSelectionOnClick
                  columns={benchColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={trays}
                  columns={trayColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  keepNonExistentRowsSelected
                  selectionModel={selectionModel}
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
          </Box>
        </AccordionDetails>
      </Accordion>
    )
  };

  const styles = {
    hidden: {
      display: "none",
    },
    importLabel: {
      color: "black",
    },
  };

  const onInputChange = ({ target }: any) => {
    console.log(target.files[0])
  }

  const { handleSubmit: handleGreenhouseSubmit, register: greenhouseRegister, control: greenhouseControl, reset: greenhouseReset, setValue: setGreenhouseValue, getValues: getGreenhouseValues } = useForm<IGreenhouse>();
  const onGreenhouseSubmit: SubmitHandler<IGreenhouse> = async data => {
    let greenhouseData = await submitGreenhouse(data);
    console.log("GREENHOUSE DATA", greenhouseData);
    handleGreenhouseClose();
    greenhouseReset();
  };

  return (
    <div>
           <ActionMenu buttons={buttons}/>
      <Grid container spacing={0} >
        <Grid item xs={12}>
          <div style={{ height: '90vh', width: '100%' }}>
            {fetchedGreenhouses.greenhouses.map((item, index) => {
              return <CustomAccordian id={item.id} key={item.id} name={item.name} heatedFloors={item.heatedFloors} bays={item.bays}></CustomAccordian>
            })}
          </div>
        </Grid>
      </Grid>


      <Dialog open={open} onClose={handleClose} maxWidth='xl' fullWidth>
        <DialogContent>
          <NewGreenhouse setOpen={setOpen}></NewGreenhouse>
        </DialogContent>
      </Dialog>

      <MovementDialog title={movementTitle} source={movementObject} sourceType={movementType} isOpen={movementOpen} handleClose={handleMovementClose}></MovementDialog>


      <BootstrapDialog
        onClose={handleGreenhouseClose}
        aria-labelledby="customized-dialog-title"
        open={greenhouseOpen}
        maxWidth='xl' fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" showHeat={true} onClose={handleGreenhouseClose}>
          Edit Greenhouse
        </BootstrapDialogTitle>
        <Box component="form" onSubmit={handleGreenhouseSubmit(onGreenhouseSubmit)}>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="Greenhouse Code"
                  placeholder="ABC"
                  type="text"
                  {...greenhouseRegister('code')}
                />
              </Grid>
              <Grid item xs={12} sm={10} md={10} lg={10}>
                <TextField
                  fullWidth
                  label="Greenhouse Name"
                  placeholder="Greenhouse XYZ"
                  type="text"
                  {...greenhouseRegister('name')}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Greenhouse Description"
                  placeholder="N/W Garden"
                  type="text"
                  {...greenhouseRegister('description')}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length (FT)"
                  placeholder="20.1"
                  type="number"
                  {...greenhouseRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getGreenhouseValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setGreenhouseValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width (FT)"
                  placeholder="15.5"
                  type="number"
                  {...greenhouseRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getGreenhouseValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setGreenhouseValue('size', calculatedSize)
                      } else {
                        setGreenhouseValue('size', 0);
                      }
                    }
                  })}

                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Total Space (SQFT)"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                  {...greenhouseRegister('size')}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  {...greenhouseRegister("updatedAt")}
                  control={greenhouseControl}
                  render={
                    ({ field: { onChange, ...restField } }) =>
                      <DatePicker
                        label="Updated At"
                        onChange={(event) => { onChange(event); }}
                        renderInput={(params) =>
                          <TextField
                            fullWidth
                            variant="outlined"
                            {...params}
                          />}
                        {...restField}
                      />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Percent Allocated Space (%)"
                  placeholder="15.5"
                  type="number"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  {...greenhouseRegister('allocatedSpace')}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Percent Available Space (%)"
                  placeholder="15.5"
                  type="number"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  {...greenhouseRegister('availableSpace')}
                />
              </Grid>
              <Grid item xs={2}>
                <Controller
                  name="heatedFloors"
                  control={greenhouseControl}
                  defaultValue={false}
                  render={({ field: { value, ref, ...field } }) => (
                    <FormControlLabel
                      label="Heated Floors?"
                      control={
                        <Checkbox
                          {...field}
                          inputRef={ref}
                          checked={!!value}
                          color="primary"
                          size={"medium"}
                          disableRipple
                        />
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleGreenhouseSubmit(onGreenhouseSubmit))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleGreenhouseClose}
        aria-labelledby="customized-dialog-title"
        open={bayOpen}
        maxWidth='lg' fullWidth
      >

        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleBayClose}>
          Add New Bay
        </BootstrapDialogTitle>
        <Box component="form">
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...bayRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bay Name"
                  placeholder="Bay XYZ"
                  type="text"
                  {...bayRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Bay 1/2/3"
                  type="text"
                  {...bayRegister("description")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  {...bayRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getBayValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setBayValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  {...bayRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getBayValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setBayValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Total Size"
                  placeholder="5000"
                  type="number"
                  defaultValue={0}
                  disabled
                  {...bayRegister("size")}
                />
              </Grid>
              <Grid item xs={2}>
                <Controller
                  name="isGrowLights"
                  control={bayControl}
                  defaultValue={false}
                  render={({ field: { value, ref, ...field } }) => (
                    <FormControlLabel
                      label="Growing Lights"
                      control={
                        <Checkbox
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                          {...field}
                          inputRef={ref}
                          checked={!!value}
                          color="primary"
                          size={"medium"}
                          disableRipple
                        />
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <Controller
                  name="isGermination"
                  control={bayControl}
                  defaultValue={false}
                  render={({ field: { value, ref, ...field } }) => (
                    <FormControlLabel
                      label="Germination"
                      control={
                        <Checkbox
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                          {...field}
                          inputRef={ref}
                          checked={!!value}
                          color="primary"
                          size={"medium"}
                          disableRipple
                        />
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleBaySubmit(onBaySubmit))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>



      <BootstrapDialog
        onClose={handleZoneClose}
        aria-labelledby="customized-dialog-title"
        open={zoneOpen}
        maxWidth='lg' fullWidth
      >
        <BootstrapDialogTitle showHeat={currentGreenhouse?.heatedFloors} showLights={currentBay?.isGrowLights} showGrass={currentBay?.isGermination} id="customized-dialog-title" onClose={handleZoneClose}>
          Add New Zone
        </BootstrapDialogTitle>
        <Box component="form" onSubmit={handleZoneSubmit(onZoneSubmit)}>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...zoneRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Zone Name"
                  placeholder="Zone Blue"
                  type="text"
                  {...zoneRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Zone 1/2/3"
                  type="text"
                  {...zoneRegister("description")}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  defaultValue={0}
                  {...zoneRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getZoneValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setZoneValue('size', calculatedSize)
                      } else {
                        setZoneValue('size', 0)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                  {...zoneRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getZoneValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setZoneValue('size', calculatedSize)
                      } else {
                        setZoneValue('size', 0)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  {...zoneRegister('size')}
                  fullWidth
                  label="Total Size"
                  placeholder="15.5"
                  type="number"
                  disabled
                  defaultValue={0}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleZoneSubmit(submitZone))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleBenchClose}
        aria-labelledby="customized-dialog-title"
        open={benchOpen}
        maxWidth='lg' fullWidth
      >
        <BootstrapDialogTitle showHeat={currentGreenhouse?.heatedFloors} showLights={currentBay?.isGrowLights} showGrass={currentBay?.isGermination} id="customized-dialog-title" onClose={handleBenchClose}>
          Add New Bench
        </BootstrapDialogTitle>
        <Box component="form" onSubmit={handleBenchSubmit(onBenchSubmit)}>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...benchRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bench Name"
                  placeholder="Bench N/W Green"
                  type="text"
                  {...benchRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Bench 1/2/3"
                  type="text"
                  {...benchRegister("description")}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  defaultValue={0}
                  {...benchRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getBenchValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setBenchValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                  {...benchRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getBenchValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setBenchValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Tray Capacity"
                  placeholder="50"
                  type="number"
                  defaultValue={50}
                  {...benchRegister("trayCapacity")}

                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={currentBench?.trays.length}
                  fullWidth
                  label="Trays Assigned"
                  placeholder="50"
                  type="number"
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField 
                  value={GetAllocatedSpace()}
                  fullWidth
                  label="Percent Allocated Space (%)"
                  placeholder="50"
                  type="number"
                  disabled
                  defaultValue={50}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={GetAvailableSpace()}
                  fullWidth
                  label="Percent Available Space"
                  type="number"
                  disabled
                  defaultValue={50}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleBenchSubmit(submitBench))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>

      <div>
        <BootstrapDialog
          onClose={handleHelpClose}
          aria-labelledby="customized-dialog-title"
          open={helpOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:bobsmarket@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>

    </div >

  );

  function GetAvailableSpace(): number {
    var allocatedSpace = GetAllocatedSpace();
    let availableSpace = 100 - allocatedSpace
    return availableSpace;
  }

  function GetAllocatedSpace(): number {
    //Assigned Work / Work Capacity * 100
    let capacity = getBenchValues('trayCapacity')
    let totalTrays = currentBench?.trays.length != undefined ? currentBench?.trays.length : 0
    let calculatedValue = ((totalTrays) / (capacity)) * 100;
    return calculatedValue;
  }
}
function GetGreenhouses(dispatch: ThunkDispatch<{ application: IApplication; user: IUserState; users: IUserState; crew: ICrewState; crews: ICrewState; greenhouses: IGreenhouseState; greenhouse: IGreenhouseState; selection: ISelection; }, undefined, AnyAction> & Dispatch<AnyAction>) {
  axios
    .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses`)
    .then(res => {
      var greenhouseResult: IGreenhouseState = {
        greenhouse: null,
        greenhouses: res.data
      };
      dispatch(setGreenhouses(greenhouseResult));
    });
}

